import { createReducer, on, ActionReducerMap } from '@ngrx/store';
import { DatasetBrowserData, PaginationTypes } from '@mode/shared/contract-common';
import * as DatasetsActions from './datasets.actions';

export const datasetsFeatureKey = 'datasetsFeatureKey';

export interface DatasetBrowser {
  datasetBrowserData: DatasetBrowserData[] | null;
  pagination: PaginationTypes.Pagination;
}

export const DatasetBrowserInitialState: DatasetBrowser = {
  datasetBrowserData: null,
  pagination: {
    page: 0,
    per_page: 0,
    count: 0,
    total_pages: 0,
    total_count: 0,
  },
};

/**
 * Will remove old state once Main Pr will merge"
 */
export interface TabState {
  datasetBrowserData: DatasetBrowserData[] | null;
  pagination: PaginationTypes.Pagination;
  searchTerm: string;
  isLoading: boolean;
}

export interface PersistDatasetBrowser {
  workspace: TabState;
  personal: TabState;
}

export const initialTabState: TabState = {
  datasetBrowserData: null,
  pagination: {
    page: 0,
    per_page: 0,
    count: 0,
    total_pages: 0,
    total_count: 0,
  },
  searchTerm: '',
  isLoading: false,
};

export const PersistDatasetBrowserInitialState: PersistDatasetBrowser = {
  workspace: initialTabState,
  personal: initialTabState,
};

export const datasetsBrowserData = createReducer(
  initialTabState.datasetBrowserData,
  on(DatasetsActions.loadDatasetBrowserDataSuccess, (state, action) => action.datasetBrowserData)
);

export const paginationReducer = createReducer(
  initialTabState.pagination,
  on(DatasetsActions.loadDatasetBrowserDataSuccess, (state, action) => action.pagination)
);

export const workspaceReducer = createReducer(
  PersistDatasetBrowserInitialState.workspace,
  on(DatasetsActions.loadDatasetBrowserDataSuccess, (state, { tabType, datasetBrowserData, pagination }) =>
    tabType === 'workspace' ? { ...state, datasetBrowserData, pagination, isLoading: false } : state
  ),
  on(DatasetsActions.updateWorkspaceSearchTerm, (state, { searchTerm }) => ({
    ...state,
    searchTerm,
  }))
);

export const personalReducer = createReducer(
  PersistDatasetBrowserInitialState.personal,
  on(DatasetsActions.loadDatasetBrowserDataSuccess, (state, { tabType, datasetBrowserData, pagination }) =>
    tabType === 'personal' ? { ...state, datasetBrowserData, pagination, isLoading: false } : state
  ),
  on(DatasetsActions.updatePersonalSearchTerm, (state, { searchTerm }) => ({
    ...state,
    searchTerm,
  }))
);

export const reducer: ActionReducerMap<PersistDatasetBrowser> = {
  workspace: workspaceReducer,
  personal: personalReducer,
};
